import React, { useState, FormEvent } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginUser } from '../store/UserSlice';
import { AppDispatch } from '../store/store'; // Adjust the path based on your actual project structure
import { EyeOutline,EyeOffOutline } from "heroicons-react";
import {toast} from "react-toastify";


export default function Login() {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const currentUrl = window.location.pathname;


  const [userPayload, setUserPayload] = useState({
    email: "",
    password: "",
    rememberMe: false, // Initialize with a boolean value
  });

  const [errors, setErrors] = useState({
    email: "",
    password: "",
    rememberMe: "",
  });

  const handleRememberMeChange = () => {
    setRememberMe(!rememberMe);
  };
   
  
  const dispatch: AppDispatch = useDispatch();
const handleButtonClick = async (e: FormEvent) => {
  e.preventDefault();
    const result = await dispatch(loginUser(userPayload));
    if (loginUser.fulfilled.match(result) && result.payload) {
      setUserPayload({
        email: '',
        password: '',
        rememberMe: false, // Reset to false after successful login
      });
      toast.success('Logged In successfully');
      const Slugdata = localStorage.getItem("SetSlug");
      if(Slugdata){
        navigate(`/program/${Slugdata}`); 
      }else if (currentUrl === '/login') {
        // Redirect to another link 
        navigate('/bookings');        
      }else{ 
        const loginData = localStorage.getItem('loginData');
        if (loginData !== null) {
            const parsedData = JSON.parse(loginData);
             if(parsedData.user.isAdmin == false){
              navigate('/bookings');
             }else{
              navigate('/admin/dashboard');
             } 
        }  
      }
    } 
};


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    setUserPayload({
      ...userPayload,
      [name]: value,
    });

    // Clear errors when user starts typing
    setErrors({
      ...errors,
      [name]: "",
    });
  };
  return (    
    
    <div className="flex flex-col lg:flex-row items-center">
      <div className="hidden lg:flex w-1/2">
      <img src='./images/loginpic.jpg' className='object-cover w-full h-screen' alt="sideimage"/>
      </div>
      <div className="w-full lg:w-1/2 p-8" >
      <form onSubmit={handleButtonClick}>
    <div className='max-w-2xl m-auto'>
    <div className='text-center'>
    <img src='./images/bluelogo.png' alt="Logo" className='mx-auto mb-6' /> 
      <h2 className='mb-2 font-gilroy text-[#263238] font-semibold text-[26px] md:text-[30px]'>Log in to your account</h2>
      <p className='text-gray-7 text-[#78909C] font-gilroy text-[18px]'>Lorem Ipsum is simply dummy text of the printing and typesetting.</p>
    </div>

     <div className='pt-10'>
       <label htmlFor='email' className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Email Address</label>
       <input className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'  type="email" name="email" placeholder='Enter your email' value={userPayload.email} id="email"
              required onChange={(e)=>handleChange(e)}/>
       {errors.email && <p className="text-red-500 text-sm">{errors.email}</p>}
     </div>

     <div className='pt-8 w-full relative'>
        <label htmlFor="password" className='block pb-2 text-[#263238] font-[18px] font-gilroy-medium'>Password</label>
        <input className='border-2 text-[#263238] bg-[#EDF2F6] font-[18px] w-full focus:outline-teal focus:bg-white font-gilroy-medium border-[#E0E4EC] rounded-[8px] py-3 px-4'  type={showPassword?"text":"password"} name="password"  value={userPayload.password} placeholder='Enter your password' id="password" required onChange={(e)=>handleChange(e)}/>

        <div className='absolute bottom-4 right-4 cursor-pointer' onClick={()=>setShowPassword(prev=>!prev)}>{showPassword?<EyeOffOutline color='#AAB7C2'/>:<EyeOutline color='#AAB7C2' />}</div>
        {errors.password && <p className="text-red-500 text-sm">{errors.password}</p>}
     </div>

     <div className='flex flex-row  mt-4 font-gilroy-medium text-[#263238]'>
      <div className='flex'>
       <input
          type="checkbox"
          className="peer"
          id="check"
          checked={rememberMe}
          onChange={handleRememberMeChange} 
        />
        <label
          htmlFor="check"
          className="flex items-center cursor-pointer"
        > 
          <span className="ml-2 text-[#263238]">Remember me</span>
        </label>
         </div>
        {/* <div className='flex-auto'>
         {currentUrl === '/login' && (
        <h4 className="p-4 mt-2 text-right">
          Forgot password?
        </h4>
      )}
         </div> */}
     </div>
    
    <button type='submit' className='bg-[#037897] w-full mt-10  py-4 text-white font-gilroy-bold uppercase rounded-[8px]'>Login</button>
    {currentUrl === '/login' && (
        <h4 className="p-4 mt-4 text-center ">
          Don’t have an account? <a href="register" className="text-[#037897]">Register</a>
        </h4>
      )}
   </div>
   </form>
    </div>
  </div>
  );
}
